import { render, staticRenderFns } from "./createPledge.vue?vue&type=template&id=0753e03a"
import script from "./createPledge.vue?vue&type=script&lang=ts"
export * from "./createPledge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports